module.exports = __webpack_public_path__ + "static/flash-splash-92a0ed0b40558d29249e9fc0404ebcb9.png";